/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PriorityRequestReachabilityFilter = {
    Reachable: 'Reachable',
    All: 'All',
    NotReachable: 'NotReachable'
} as const;
export type PriorityRequestReachabilityFilter = typeof PriorityRequestReachabilityFilter[keyof typeof PriorityRequestReachabilityFilter];


export function instanceOfPriorityRequestReachabilityFilter(value: any): boolean {
    for (const key in PriorityRequestReachabilityFilter) {
        if (Object.prototype.hasOwnProperty.call(PriorityRequestReachabilityFilter, key)) {
            if (PriorityRequestReachabilityFilter[key as keyof typeof PriorityRequestReachabilityFilter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PriorityRequestReachabilityFilterFromJSON(json: any): PriorityRequestReachabilityFilter {
    return PriorityRequestReachabilityFilterFromJSONTyped(json, false);
}

export function PriorityRequestReachabilityFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriorityRequestReachabilityFilter {
    return json as PriorityRequestReachabilityFilter;
}

export function PriorityRequestReachabilityFilterToJSON(value?: PriorityRequestReachabilityFilter | null): any {
    return value as any;
}

export function PriorityRequestReachabilityFilterToJSONTyped(value: any, ignoreDiscriminator: boolean): PriorityRequestReachabilityFilter {
    return value as PriorityRequestReachabilityFilter;
}

